import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/LP/FlamingoLP/Functions/Functions'

const Functions: React.FunctionComponent = () => {
  return (
    <>
      <CustomHead
        keyword={'flamingo, フラミンゴ, サイト変換,アダプティブウェブ, レスポンシブウェブ, スマホ最適化, スマホサイト'}
        image={'https://aitria.co.jp/img/LP/flamingo/ogp.png'}
        url={'https://aitria.co.jp/products/flamingo/functions/'}
        title="機能 | ウェブシステム モダナイゼーション flamingo | サービス | Aitria（アイトリア）"
        description="Aitria（アイトリア）のモダナイゼーションツールには自由度の高い画面刷新および安心・安定のサイト運用を支える様々な機能があります。ここでは大きく３つの機能を紹介します。"
        faviconPng="/img/LP/flamingo/favicon_f.png"
        faviconSvg="/img/LP/flamingo/favicon_f.svg"
      />
      <Template />
    </>
  )
}

export default Functions
